import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSierraFreightHandoff = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSierraFreightHandoff);
};
